import { ReactNode } from 'react'

import { Id, RowType } from '../types'
import { Rows } from './Rows'
import { SummaryCell } from './SummaryCell'

type Props<TCol extends { id: Id }> = {
    rows: RowType<TCol>[]
    cols: TCol[]
    gridTemplateColumns: string
    withSummary: boolean
    summaryContent?: ReactNode
}

/** Header or footer rows, with the pinned summary cell beside them when the grid has a summary column. */
export function SectionRows<TCol extends { id: Id }>({ rows, cols, gridTemplateColumns, withSummary, summaryContent }: Props<TCol>) {
    const content = rows.map(({ key, ...row }) => <Rows key={key} cols={cols} gridTemplateColumns={gridTemplateColumns} {...row} />)
    if (!withSummary) return content

    return (
        <>
            <div>{content}</div>
            <SummaryCell>{summaryContent}</SummaryCell>
        </>
    )
}
